@if (lines().length === 0) {
  <div class="empty" i18n="@@einvoice.xml-view.no-source">No source XML available.</div>
} @else {
  <section class="xml-view" aria-label="Formatted source XML" i18n-aria-label="@@einvoice.xml-view.aria-label">
    <header>
      <div class="title">
        <span>{{xmlFileName() || 'source.xml'}}</span>
        <span class="meta">{{lines().length}} lines / {{sourceLineCount()}} source nodes</span>
      </div>
      <div class="tools">
        <button type="button" class="copy-xml" [class.copied]="copiedXml()" (click)="copyXml()">
          <span class="copy-default" i18n="@@einvoice.xml-view.copy-xml">Copy XML</span>
          <span class="copy-done" aria-hidden="true">✓</span>
        </button>
      </div>
    </header>
    <div class="code" role="table" aria-label="Formatted source XML" i18n-aria-label="@@einvoice.xml-view.aria-label">
      @for (line of lines(); track line.id) {
        <div class="xml-row"
          [attr.data-line-id]="line.id"
          [attr.data-source-path]="line.path"
          [class.selected]="!!line.path && selectedLinePaths().has(line.path)"
          [class.active]="line.path === activeLinePath()"
          [class.search-match]="searchResultIds().has(line.id)"
          [class.current-search-match]="line.id === currentSearchResultId()">
          <span class="line-number">{{line.lineNumber}}</span>
          <button type="button" class="xml-line" [class.selectable]="line.selectable" (click)="select(line, $event)">
            @for (token of line.tokens; track $index) {
              <span [class]="'token-' + token.kind">{{token.text}}</span>
            }
          </button>
          @if (line.path && lineTermsByPath().get(line.path); as lineTerms) {
            <button type="button" class="terms" [class.terms--selectable]="line.selectable" (click)="select(line, $event)">{{lineTerms}}</button>
          }
          <button type="button" class="copy-line" [class.copied]="line.id === copiedLineIdValue()" (click)="copyLine(line, $event)" i18n-title="@@einvoice.xml-view.copy-line" title="Copy line">
            <span class="copy-default" i18n="@@einvoice.xml-view.copy">Copy</span>
            <span class="copy-done" aria-hidden="true">✓</span>
          </button>
        </div>
      }
    </div>
  </section>
}